import React, { useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, get, find, isUndefined, filter, sumBy } from "lodash";
import { GetLevelFourDropDownApi } from "../LevelFour/LevelFourAction";
import { AddVoucherApi, SubmitCashReceipt, DeleteCashReceipt, ResetCashReceipt } from "./VoucherAction";
import { previewVoucher, mergeNames } from '../../../../../global/globalFunctions'
import { useEffect } from "react";
import { setHeading } from "../../../accounts/account.actions";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import MaterialTable from "material-table";
import Swal from 'sweetalert';
import moment from 'moment';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const CashReceiptVoucher = (props) => {
    const [accountNo, setaccountNo] = useState(1);
    const [cashAccountTitle, setCashAccountTitle] = useState();
    const [voucher, setVoucher] = useState();
    const [level4Id, setLevel4Id] = useState(1);
    const [selectedAccount, setSelectedAccount] = useState();
    const [cashId, setCashId] = useState("6439abd6b990438a2450690a");
    const [datestate, setDatestate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [level4Label, setLevel4Lablel] = useState(`3-1-1-1/CASH`);
    const [cashAccountTitleKey, setCashAccountTitleKey] = useState();
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


    const SaveCashReceiptVoucher = () => {
        let dt = cash.map((x) => {
            return x.cashRecipetData;
        })
        let cashData = [{
            voucherDescription: mergeNames(dt, 'voucherDescription'),
            voucherAmount: sumBy(cash, item => Number(item.cashRecipetData.voucherAmount)),
            billNumber: mergeNames(dt, 'billNumber'),
            accountTittle: cashAccountTitle,
            levelFourId: accountNo,
            voucherDate: datestate,
            accountType: "2",
            crossAccount: mergeNames(dt, 'accountTittle'),
            debit: sumBy(cash, item => Number(item.cashRecipetData.voucherAmount)),
            credit: "",
        }]
        props.AddVoucherApi({
            voucherTypeId: "2",
            vocDate: datestate,
            levelFourId: accountNo,
            cashAccTittle: cashAccountTitle,
            totalAmount: sumBy(cash, item => Number(item.cashRecipetData.voucherAmount)),
            voucher: voucher,
            voucherData: [...dt, ...cashData],
            voucherType: "CRV",
        },
            handleVisible,
            handleDangerVisible
        );
        setaccountNo(1)
        setCashAccountTitle("")
        setCashAccountTitleKey("")
        setSelectedAccount("")
        props.ResetCashReceipt();
    };
    const handleVisible = (data, msg) => {
        setAlertVisible(true)
        setTimeout(() => {
            setAlertVisible(false)
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            buttons: ["Cancel", "Print Voucher"]
        }).then((willPrint) => {
            if (willPrint) {
                previewVoucher(data, "Pending");
            }
        })
    }
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true)
        setTimeout(() => {
            setDangerVisibleAlert(false)
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    }

    const cash = props.cashRecipet;
    const [values, setValues] = useState({
        voucherDescription: "",
        voucherAmount: "",
        billNumber: "",
        accountTittle: "",
        levelFourId: "",
        voucherDate: "",
        accountType: "1",
        credit: "",
        debit: "",
        crossAccount: ""
    });

    const inputEventAccount = (selectedOption, type) => {
        setLevel4Id(selectedOption.value);
        setValues({ levelFourId: selectedOption.value });
    };

    const inputEvent1Account = (selectedOption) => {
        setLevel4Id(selectedOption.value);
        setValues({
            ...values,
            "levelFourId": selectedOption.value,
            "accountTittle":
                get(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value), "allLevelKey", 0) + "(" +
                get(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value), "levelFourName", 0) + ")",
        });
    };

    const inputEvent = (event) => {
        event.target.name == "voucherDate" && setDatestate(event.target.value);
        if (event.target.name == "voucherAmount") {
            setValues({
                ...values,
                [event.target.name]: event.target.value,
                credit: Number(event.target.value)
            })
        } else {
            setValues({
                ...values,
                [event.target.name]: event.target.value,
            })
        }
    };

    const cashAccountNoTop = !isEmpty(props.levelFourDropDownList) && props.levelFourDropDownList.filter((x) => x.levelThreeId === cashId).map((y) => {
        let data = {
            value: y._id,
            label: `${y.allLevelKey} / ${y.levelFourName}`,
        };
        return data;
    });

    const PostVoucher = () => {
        let newVal = values;
        if (!isEmpty(datestate)) newVal.voucherDate = datestate;
        props.SubmitCashReceipt(newVal);
        setValues({
            voucherDescription: "",
            voucherAmount: "",
            billNumber: "",
            accountTittle: "",
            levelFiveId: "",
            voucherDate: "",
            accountType: "1",
            credit: "",
            debit: "",
            crossAccount: ""
        });
        setLevel4Lablel("")
    };

    const cashAccountNo = !isEmpty(props.levelFourDropDownList) && props.levelFourDropDownList.map((x) => {
        let data = {
            value: x._id,
            label: `${x.allLevelKey} / ${x.levelFourName}`,
        };
        return data;
    });
    const handleChangeAccountNo = (selectedOption) => {
        setaccountNo(selectedOption.value);
        setCashAccountTitle(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value).levelFourName);
        setCashAccountTitleKey(find(props.levelFourDropDownList, (x) => x._id === selectedOption.value).allLevelKey);
        setSelectedAccount(selectedOption.label)
    };


    useEffect(() => {
        props.setHeading("Cash Receipt Voucher");
        props.GetLevelFourDropDownApi();
    }, []);


    return (
        <>
            {props.isFetchingLevelFourDropDown || props.isAddingVoucher ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="border"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <div style={{ marginTop: '-2%' }}>
                    <Container fluid>
                        <Row>
                            <Col lg="4" sm="12">
                                <Form.Group>
                                    <Form.Label><b>Voucher Date *</b></Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="voucherDate"
                                        value={datestate}
                                        max={moment(new Date()).format("YYYY-MM-DD")}
                                        onChange={inputEvent}
                                        disabled={!isEmpty(props.cashRecipet)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label><b>Select Cash Account *</b></Form.Label>
                                    <Select
                                        value={{ label: cashAccountTitle }}
                                        isDisabled={isUndefined(level4Id) || !isEmpty(accountNo)}
                                        placeholder="Select Cash Account"
                                        onChange={handleChangeAccountNo}
                                        options={filter(cashAccountNoTop, x => x.value !== values.levelFourId)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label><b>Account Type *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Account Type"
                                        value="Debit"
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Select Account *</b></Form.Label>
                                    <Select
                                        value={{ label: values.accountTittle }}
                                        placeholder="Select Account"
                                        onChange={(inputEventAccount, inputEvent1Account)}
                                        options={filter(cashAccountNo, x => x.value !== accountNo)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Account Type *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Account Type"
                                        value="Credit"
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Bill Number</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Bill Number"
                                        name="billNumber"
                                        value={values.billNumber}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Description</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Description"
                                        // id="descriptionID"
                                        name="voucherDescription"
                                        value={values.voucherDescription}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label><b>Voucher Amount *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Voucher Amount"
                                        // id="amountID"
                                        name="voucherAmount"
                                        value={values.voucherAmount}
                                        onChange={inputEvent}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>


                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '80px', marginTop: '15px' }}>
                            <div>
                                <Button
                                    variant="contained"
                                    endIcon={<SendIcon />}
                                    size="large"
                                    disabled={isEmpty(level4Id) || isEmpty(accountNo) || isEmpty(values.voucherAmount)}
                                    onClick={() => { PostVoucher() }}>
                                    POST VOUCHER
                                </Button>
                            </div>
                            <div>
                                <Button
                                    variant="contained"
                                    endIcon={<SendIcon />}
                                    size="large"
                                    onClick={SaveCashReceiptVoucher}
                                    disabled={isEmpty(cash)}>
                                    SAVE VOUCHER
                                </Button>
                            </div>
                        </div>

                        <div className="main" style={{ marginTop: '10px' }} >
                            <MaterialTable
                                title={`VOUCHER TOTAL : ${sumBy(cash, item => Number(item.cashRecipetData.voucherAmount))}`}
                                columns={[
                                    { title: "Date", field: "cashRecipetData.voucherDate" },
                                    { title: "Account Name", field: "cashRecipetData.accountTittle" },
                                    { title: "Bill", field: "cashRecipetData.billNumber" },
                                    { title: "Description", field: "cashRecipetData.voucherDescription" },
                                    { title: "Amount", field: "cashRecipetData.voucherAmount", render: rowData => `${rowData.cashRecipetData.voucherAmount}/-` },
                                    { title: "Debit / Credit", field: "cashRecipetData.accountType", render: (rowData) => rowData.cashRecipetData.accountType === "1" ? "Credit" : "Debit" },
                                ]}
                                data={cash}
                                options={{
                                    actionsColumnIndex: -1,
                                    exportButton: false,
                                    exportAllData: false,
                                    paging: false,
                                    pageSize: 50,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [50, 100, 150, 200],
                                    headerStyle: {
                                        position: "sticky",
                                        top: 0,
                                        color: "#00BBBB",
                                        fontWeight: "550",
                                        onRowAdd: "none",
                                    },
                                }}
                                editable={{
                                    onRowDelete: (oldData) =>
                                        new Promise((resolve) => {
                                            setTimeout(() => {
                                                resolve();
                                                props.DeleteCashReceipt(oldData);
                                            }, 600);
                                        }),
                                }}
                            />
                        </div>

                    </Container>
                </div>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        AddVoucherApi: (data, handleVisible, handleDangerVisible) => dispatch(AddVoucherApi(data, handleVisible, handleDangerVisible)),
        SubmitCashReceipt: (data) => dispatch(SubmitCashReceipt(data)),
        DeleteCashReceipt: (id) => dispatch(DeleteCashReceipt(id)),
        ResetCashReceipt: () => dispatch(ResetCashReceipt()),
        GetLevelFourDropDownApi: () => dispatch(GetLevelFourDropDownApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingVoucher: state.VouchersReducer.isAddingVoucher,
    cashRecipet: state.VouchersReducer.cashRecipet,
    isFetchingLevelFourDropDown: state.LevelFourReducer.isFetchingLevelFourDropDown,
    levelFourDropDownList: state.LevelFourReducer.levelFourDropDownList,
});

export default connect(mapStateToProps, mapDispatchToProps)(CashReceiptVoucher);